// src/supabase.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://vqgujfkplvwclfdvvmwr.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZxZ3VqZmtwbHZ3Y2xmZHZ2bXdyIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTcyMjM0MTM4MSwiZXhwIjoyMDM3OTE3MzgxfQ.I6qrjH_VwtMbgm1QDwrQmkptiiHEc4WFwMro8AI7TKM';

export const supabase = createClient(supabaseUrl, supabaseKey);